<svelte:options runes={true} />

<script lang="ts">
	import { createEventDispatcher, onMount } from "svelte";

	interface PlayerProps {
		src: string;
		autoplay?: boolean;
		style?: string;
	}

	let { src, autoplay = false, style = "" }: PlayerProps = $props();

	const dispatch = createEventDispatcher();

	let playerEl: HTMLElement | null = $state(null);

	let ready = $state(false);

	onMount(async () => {
		ready = true;
		await import("@wistia/wistia-player");
		playerEl?.addEventListener("ended", () => dispatch("ended"));
	});
</script>

{#if ready}
	<wistia-player bind:this={playerEl} class="aspect-video w-full" media-id={src} {autoplay} {style}></wistia-player>
{/if}
